import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    width: '100%',
    boxSizing: 'border-box'
  },
  skeletonCard: {
    height: theme.spacing(20),
    borderRadius: theme.shape.borderRadius,
    transform: 'none'
  },
  empty: {
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  // Compact pagination lives in a plain div. MUI v4 lays the toolbar out in a
  // single nowrap row, so let it wrap and drop the flexible spacer instead of
  // forcing the caption/select/range/arrows past a 375px viewport.
  paginationRoot: {
    minWidth: 0,
    width: '100%',
    boxSizing: 'border-box'
  },
  paginationToolbar: {
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    rowGap: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: { justifyContent: 'center' }
  },
  paginationSpacer: { display: 'none' },
  paginationActions: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('sm')]: { marginLeft: theme.spacing(2.5) }
  },
  headerCell: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  headerGroupCell: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
  }
}));
